import Cookies from 'js-cookie';

const CLOSE_DEEPLINK_BANNER = '@@CLOSE_DEEPLINK_BANNER';
const CLOSE_COOKIE_BANNER = '@@CLOSE_COOKIE_BANNER';
const UPDATE_DEEPLINK = '@@UPDATE_DEEPLINK';
const UPDATE_JOURNEY = '@@UPDATE_JOURNEY';
const UPDATE_LANDING_AB = '@@UPDATE_LANDING_AB';

export function closeCookieBanner() {
  Cookies.set('bisc__ack', 1);

  return {
    type: CLOSE_COOKIE_BANNER,
  };
}

export function closeDeeplinkBanner() {
  return {
    type: CLOSE_DEEPLINK_BANNER,
  };
}

export function updateDeepLink(value) {
  return {
    type: UPDATE_DEEPLINK,
    value,
  };
}

export function updateJourney(value) {
  return {
    type: UPDATE_JOURNEY,
    value,
  };
}

export function updateLandingAB(value) {
  return {
    type: UPDATE_LANDING_AB,
    value,
  };
}

export function overlaysReducer(state = {
  deeplink:         null,
  userClosed:       false,
  cookiesAccepted:  false,
  isJourneyOn:      false,
  open:             false,
  landingAB:        null,
}, action) {
  const isCurrentlyOpen = state.userClosed ? false : true;
  switch (action.type) {
    case CLOSE_DEEPLINK_BANNER:
      return {...state, open: false, userClosed: true};
    case CLOSE_COOKIE_BANNER:
      return {...state, cookiesAccepted: true}
    case UPDATE_DEEPLINK:
      return {...state, deeplink: action.value, open: isCurrentlyOpen};
    case UPDATE_JOURNEY:
      return {...state, isJourneyOn: !!action.value || false};
    case UPDATE_LANDING_AB:
      return {...state, landingAB: action.value || null};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ../src/client/state/overlays.js